<template>
<form @submit.prevent="$router.push({ name: 'userIndex' })" method="get" class="login-form">
  <div class="login-form__input u-mb">
    <label for="user">Usuario: </label>
    <input class="u-pv-tiny" type="text" name="user" id="email" required v-model="user">
  </div>
  <div class="login-form__input u-mb">
    <label for="password">Password: </label>
    <input class="u-pv-tiny" type="password" name="password" id="password" required v-model="password">
  </div>
  <div class="login-form__button">
    <input
      class="btn btn--primary"
      type="submit"
      value="Entrar"
      :disabled="!isFormFilled"
    >
  </div>
</form>
</template>

<script>
export default {
  name: 'loginForm',

  data() {
    return {
      user: '',
      password: ''
    }
  },

  computed: {
    isFormFilled() {
      return Boolean(this.user && this.password)
    }
  },
}
</script>
